import { NamespacedStoreState } from '@Types/store.types';
import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

export const popupSelector = createSelector(
	parseNamespace,
	state => state.popup,
);

export const popupSelectedSelector = createSelector(
	popupSelector,
	baseState => baseState?.selected,
);

export const popupAssetSelector = createSelector(
	popupSelector,
	baseState => baseState?.asset,
);

export const popupInspectionsSelector = createSelector(
	popupSelector,
	baseState => baseState?.inspections,
);

export const popupInspectionsLoadingSelector = createSelector(
	popupInspectionsSelector,
	baseState => baseState?.loading,
);

export const popupInspectionsDataSelector = createSelector(
	popupInspectionsSelector,
	baseState => baseState?.data,
);

export const popupLastInspectionDate = createSelector(
	popupInspectionsDataSelector,
	inspections => {
		if (inspections) {
			return inspections[0]?.surveyDateTime;
		}
	},
);

export const popupServiceGradeRating = createSelector(
	popupInspectionsDataSelector,
	inspections => {
		if (inspections) {
			return inspections[0]?.ratings?.serviceGradeRating;
		}
	},
);

export const popupStructuralGradeRating = createSelector(
	popupInspectionsDataSelector,
	inspections => {
		if (inspections) {
			return inspections[0]?.ratings?.structuralGradeRating;
		}
	},
);

export const popupInspectionVersion = createSelector(
	popupInspectionsDataSelector,
	inspections => {
		if (inspections) {
			return inspections[0]?.inspectionVersion;
		}
	},
);

export const popupInspectionQuickRating = createSelector(
	popupInspectionsDataSelector,
	inspections => {
		if (inspections) {
			return inspections[0]?.ratings?.quickRating;
		}
	},
);

export const popupRiskSelector = createSelector(
	popupSelector,
	baseState => baseState?.risk,
);

export const popupRiskLoadingSelector = createSelector(
	popupRiskSelector,
	baseState => baseState?.loading,
);

export const popupRiskDataSelector = createSelector(
	popupRiskSelector,
	baseState => baseState?.data,
);

export const popupRiskGrade = createSelector(popupRiskDataSelector, risk => {
	if (risk) {
		return risk.GRADE;
	}
});

export const popupSelectedAssetSelector = createSelector(
	[
		popupAssetSelector,
		popupSelectedSelector,
		popupLastInspectionDate,
		popupRiskGrade,
		popupInspectionQuickRating,
		popupServiceGradeRating,
		popupStructuralGradeRating,
		popupInspectionVersion,
	],
	(
		asset,
		popup,
		lastInpsectionDate,
		riskGrade,
		quickRating,
		popupServiceGradeRating,
		popupStructuralGradeRating,
		popupInspectionVersion,
	) => {
		if (!asset || !popup) return null;
		if (
			asset.assetId !== popup.assetId ||
			asset.assetType !== popup.assetType
		)
			return null;
		return {
			...asset,
			lastInpsectionDate,
			riskGrade,
			quickRating,
			popupServiceGradeRating,
			popupStructuralGradeRating,
			popupInspectionVersion,
		};
	},
);
